import {Button, Grid, Loader, Typography} from '@yandex-delivery/blocks'
import {useCallback, useEffect, useRef} from 'react'

import {i18n} from 'src/shared/config'
import {DestinationPointDeliveryMethod} from 'src/shared/types'

import {DropOffPointDetails} from './drop-off-point-details/DropOffPointDetails'
import {useSelectedPointInformation} from './hooks'
import {PickupPointDetails} from './pickup-point-details/PickupPointDetails'
import type {Props} from './types'

export function PointDetails(props: Props) {
  const {point, onChoose, pointType} = props
  const ref = useRef<HTMLDivElement>(null)
  const {isPending, payload} = useSelectedPointInformation(pointType)

  const selectPointHandler = useCallback(() => {
    onChoose(point)
  }, [onChoose, point])

  useEffect(() => {
    if (ref.current) {
      ref.current.scrollIntoView({block: 'center'})
    }
  }, [ref])

  return isPending ? (
    <Loader />
  ) : (
    <Grid ref={ref} direction="column" container>
      {pointType === DestinationPointDeliveryMethod.PickUpPoint ? (
        <PickupPointDetails point={point} result={payload} />
      ) : (
        <DropOffPointDetails point={point} />
      )}

      <Grid container item>
        <Grid item xs>
          <Button onPress={selectPointHandler} size="m" variant="action" fullWidth>
            <Typography Component={Grid} justify={'center'} thickness="medium" variant="body2" container>
              {i18n('ndd.pickup_points.select_point', 'Выбрать')}
            </Typography>
          </Button>
        </Grid>
      </Grid>
    </Grid>
  )
}
